export default function({ $axios, $config, app, route }, inject) {
    const hefesto       = $axios.create({
        baseURL: $config.hefesto.baseURL,
        headers: $config.hefesto.headers
    });
    const hefesto_file  = $axios.create({
        baseURL: $config.hefesto_file.baseURL,
        headers: $config.hefesto_file.headers,
    });
    const agent         = $axios.create({
        baseURL: $config.agent.baseURL,
        headers: $config.agent.headers,
    });
    const billing       = $axios.create({
        baseURL: $config.billing.baseURL,
        headers: $config.billing.headers,
    });
    hefesto.interceptors.request.use((config) => {
        let app_version = `${ config.url.indexOf('?') >= 0 ? `&` : `?` }app_version=${ ![null, undefined].includes( app.$cookies.get('app-version') ) ? app.$cookies.get('app-version') : null }`;
        let storefront  = `${ route.params.storefront ? `${ ![null, undefined].includes( route.params.storefront ) ? `&storefront=${ route.params.storefront }` : '' }` : '' }`;

        config.url = `${ config.url }${ app_version }${ storefront }`;

        if ( app.$cookies.get('token-app') ) {

            config.headers.common['x-access-token'] = `${ app.$cookies.get('token-app')  } ${ $config.marketplace } ${ $config.application_type }`;
        } 
        else {
            
            config.headers.common['x-access-token'] = `${ $config.hefesto.defaultToken } ${ $config.marketplace } ${ $config.application_type }`;
        }
        return config;
    }, (error) => {
        
        return Promise.reject(error);
    });
    hefesto.interceptors.response.use(function (response) {
        
        if( response.data?.app_version && `${ app.$cookies.get('app-version') }` === 'null' ){

            app.$cookies.set('app-version', response.data?.app_version, { path: '/', maxAge: 60 * 60 * 24 * 7 } );
        }
        return response;
    }, function (error) {

        return Promise.reject(error);
    });

    inject('hefesto'        , hefesto);
    inject('hefesto_file'   , hefesto_file);
    inject('agent'          , agent);
    inject('billing'        , billing);
};